import request from './minioRequest';

// 获取minio下载任务
export const createMinioDownload = (url, data) => {
  return request.get(
    url,
    data
  );
};

// 下载文件（带认证信息）
export const downloadMinioFile = (url, signatureInfo) => {
  return request.get(url, {
    headers: {
      'Authorization': signatureInfo.authorization,
      'X-app-id': signatureInfo['x-app-id'],
      'X-user-id': signatureInfo['x-user-id'],
      'X-date': signatureInfo['x-date'],
      'X-nonce': signatureInfo['x-nonce'],
      'X-body-sha256': signatureInfo['x-body-sha256']
    },
    responseType: 'blob' // 重要：设置响应类型为blob以处理文件下载
  });
};

// 上传文件(带认证信息)
export const uploadMinioFile = (url, file, signatureInfo, onProgress) => {
  // 创建 FormData 对象
  const formData = new FormData();
  formData.append('file', file);

  return request.post(url, formData, {
    headers: {
      'Authorization': signatureInfo.authorization,
      'X-APP-ID': signatureInfo['x-app-id'],
      'X-User-Id': signatureInfo['x-user-id'],
      'X-Date': signatureInfo['x-date'],
      'X-Nonce': signatureInfo['x-nonce'],
      'X-Body-SHA256': signatureInfo['x-body-sha256'],
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = progressEvent.loaded / progressEvent.total;
        onProgress(percentCompleted);
      }
    }
  });
};

export const uploadMinioFileNew = (url, file, onProgress) => {
  // 创建 FormData 对象
  const formData = new FormData();
  formData.append('file', file);

  return request.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = progressEvent.loaded / progressEvent.total;
        onProgress(percentCompleted);
      }
    }
  });
};

// 初始化分块上传任务
export const initResumableUpload = (domain, params) => {
  return request.post(domain + '/api/minio/api/resumable/init', null, { params });
};

// 上传文件分块
export const uploadChunk = (domain, params, fileChunk, appId, encryptedData) => {
  const formData = new FormData();
  formData.append('file', fileChunk);

  return request.post(domain + '/api/minio/api/resumable/chunk', formData, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-App-Id': appId,
      'Encrypted-Data': encryptedData
    }
  });
};

// 完成分块上传并合并文件
// export const completeResumableUpload = (domain, params) => {
//   return request.post(domain + '/api/minio/api/resumable/complete', null, { params });
// };
export const completeResumableUpload = (domain, params, appId, encryptedData) => {
  return request.post(domain + '/api/minio/api/resumable/complete', null, { 
    params,
    headers: {
      'X-App-Id': appId,
      'Encrypted-Data': encryptedData
    }
  });
};

// 获取上传进度
// export const getResumableProgress = (domain, params) => {
//   return request.get(domain + '/api/minio/api/resumable/progress', { params });
// };
export const getResumableProgress = (domain, params, appId, encryptedData) => {
  return request.get(domain + '/api/minio/api/resumable/progress', { 
    params,
    headers: {
      'X-App-Id': appId,
      'Encrypted-Data': encryptedData
    }
  });
};

// 初始化 Minio 下载 (获取 Token)
export const initMinioDownload = (domain, fileKey) => {
  return request.get(domain + '/api/minio/api/download/init', { params: { fileKey } });
};

// 获取 Minio 下载文件的完整 URL
export const getMinioDownloadUrl = (domain, fileKey, token) => {
  // 构建带参数的下载地址
  return domain + `/api/minio/api/download/file?fileKey=${fileKey}&downloadToken=${token}&startPos=-1&speedLimit=-1`;
};


// WEBPACK FOOTER //
// ./src/utils/api/minioApis.js